/**
 * Worker的互动层消息通信器
 */
import ChildBridge from '../ChildBridge';
import { ChannelMessage } from '../ChannelMessage';
import { pushMessageCallback, removeMessageCallback } from '../../Worker/messageCallbackQuene';

const ctx: Worker = self as any;

export default class WorkerChildBridge extends ChildBridge {
  protected onPostMessage(param: ChannelMessage) {
    ctx.postMessage({
      type: 'postMessage',
      value: param,
    });
  };
  protected onRemoveListener(cb: (...args: any[]) => void) {
    removeMessageCallback(cb);
  };
  protected onAddListener(cb: (...args: any[]) => void) {
    pushMessageCallback(cb);
  };
}
